
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import AerialHeroSection from './components/AerialHeroSection';
import AerialBenefitsSection from './components/AerialBenefitsSection';

export default function Aerial() {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <AerialHeroSection />
      </main>
      <Footer />
    </div>
  );
}
